import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PageService } from 'src/app/services/page.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.page.html',
  styleUrls: ['./privacy-policy.page.scss'],
})
export class PrivacyPolicyPage implements OnInit {
  pageDetail:any = null;

  constructor(
    private modalCtrl: ModalController,
    private pageService: PageService,
    private router:Router,
  ) { }

  ngOnInit() {
    this.pageService.getPageDetail('Datenschutz').subscribe( 
      response => {
        this.pageDetail = response.data;
    },
    error => {
      console.log(error);        
    })
  }

  async close() {
    await this.modalCtrl.dismiss();
  }

  backHome(){
    this.router.navigate(['home']);
  }

}
